import React from 'react';
import Alert from 'react-bootstrap/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.scss';

export interface IAlert {
  variant:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'dark'
    | 'light';
  title?: string | any;
  text?: string | any;
  show: boolean;
  renderContent?: () => any;
  largeIcon?: boolean;
  icon?: any;
  className?: string;
  showTitleIcon?: boolean;
}

const StyledAlert = ({
  variant,
  title,
  text,
  show,
  renderContent,
  icon,
  largeIcon,
  className,
  showTitleIcon,
}: IAlert) => {
  const renderIcon = () => {
    if (icon) return icon;

    switch (variant) {
      case 'primary':
      case 'info':
      case 'dark':
      case 'danger':
      case 'secondary':
        return <FontAwesomeIcon icon={['fas', 'info-circle']} />;
      case 'success':
        return <FontAwesomeIcon icon={['fas', 'check']} />;
      case 'warning':
        return <FontAwesomeIcon icon={['fas', 'exclamation-circle']} />;
      default:
        return;
    }
  };

  return (
    <Alert
      role={'alert'}
      variant={variant}
      show={show}
      className={`${largeIcon ? 'alert-with-large-icon' : ''} ${className || ''}`}
    >
      {largeIcon ? (
        <>
          <div className="alert-icon-wrapper">{renderIcon()}</div>
          <div className="alert-text-wrapper">
            {largeIcon ? '' : <>&nbsp;</>}
            {title ? (
              <>
                <Alert.Heading>
                  <b>{title}</b>
                </Alert.Heading>
              </>
            ) : null}
            <div>{text}</div>
          </div>
          {renderContent && renderContent()}
        </>
      ) : (
        <>
          <div>{showTitleIcon ? null : renderIcon()}</div>
          <div className="alert-text-wrapper">
            {title ? (
              <>
                <Alert.Heading>
                  <b>{title}</b>
                </Alert.Heading>
              </>
            ) : null}
            {text ? (
              <div className={` ${showTitleIcon ? 'icon-text-wrapper' : ''}`}>
                {showTitleIcon ? renderIcon() : null}
                <div className={`alert-text ${showTitleIcon ? 'icon-text' : ''}`}>
                  {text}
                </div>
              </div>
            ) : null}
          </div>
        </>
      )}
    </Alert>
  );
};

export default StyledAlert;
